import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { EditChartsTickerComponent } from "../edit-charts-ticker/edit-charts-ticker.component";

@Component({
  selector: "app-charts-ticker-modal",
  templateUrl: "./charts-ticker-modal.component.html",
  styleUrls: ["./charts-ticker-modal.component.scss"],
})
export class ChartsTickerModalComponent implements OnInit, OnChanges {
  @Input() modalVisible: boolean;
  @Input() addRowTableData: Array<any>;
  @Input() watchlists: Array<any>;
  @Input() recentlyVisitedCompanies: Array<any>;
  @Input() peerCompanies: Array<any>;
  @Input() mpt: number;
  @Input() maxHeight: string;
  @Input() type: string;
  @Input() max: number;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onTickerUpdate = new EventEmitter();
  @Output() onModalCancel = new EventEmitter();
  watchlisNameInput = "";
  selectedTickers: Array<any> = [];
  recentlyVisited: Array<any> = [];
  modalData: Array<any> = [];
  stdLineItems: Array<any> = [];
  legacyUrl = `${window.caUrl}/app`;
  visible: boolean;
  selectedMenuItem = "";
  lineItems: Array<any> = [];
  watchlistData: Array<any> = [];
  allItems: Array<any> = [];
  recentCompanies: Array<any> = [];
  @ViewChild(EditChartsTickerComponent)
  editChartModal: EditChartsTickerComponent;

  ngOnInit() {
    let wData = [];
    for (let i = 0; i < this.watchlistData.length; i++) {
      wData = this.watchlistData[i].company_info.map((el) => {
        const addedRowData = this.addRowTableData.find((obj) => {
          return obj.ticker === el.ticker;
        });
        if (addedRowData) {
          addedRowData.isSelected = true;
          const m = el.mpt;
          el = addedRowData;
          el["mpt"] = m;
        }
        return el;
      });
      this.watchlistData[i].company_info = JSON.parse(JSON.stringify(wData));
    }
    this.selectedMenuItem =
      this.watchlistData.length && this.watchlistData[0].watchername;
    this.recentlyVisited =
      this.watchlistData.length && this.watchlistData[0].company_info;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.addRowTableData &&
      changes.addRowTableData.currentValue !==
        changes.addRowTableData.previousValue
    ) {
      this.modalData = this.addRowTableData ? [...this.addRowTableData] : [];
    }
    if (
      changes.watchlists &&
      changes.watchlists.currentValue !== changes.watchlists.previousValue
    ) {
      this.watchlistData = JSON.parse(JSON.stringify(this.watchlists));
    }
    if (
      changes.recentlyVisitedCompanies &&
      changes.recentlyVisitedCompanies.currentValue !==
        changes.recentlyVisitedCompanies.previousValue
    ) {
      this.recentCompanies = JSON.parse(
        JSON.stringify(this.recentlyVisitedCompanies),
      );
      const recentViewCompanies = this.recentlyVisitedCompanies.map((el) => {
        const company = {
          name: el.name,
          ticker: el.ticker,
          sli_comps_id: 0,
          mpt: el.mpt,
          isSelected: false,
        };
        return company;
      });
      const recentViewCompany = {
        watchername: "Recently viewed (up to 30)",
        company_info: recentViewCompanies,
      };

      const peerCompanies = this.peerCompanies.map((pc) => {
        const company = {
          name: pc.name,
          ticker: pc.ticker,
          sli_comps_id: 0,
          mpt: pc.mpt,
          isSelected: false,
        };
        return company;
      });
      const peerData = {
        watchername: "Suggested Peers",
        company_info: peerCompanies,
      };

      this.watchlistData.unshift(recentViewCompany);
      if (peerCompanies.length) {
        this.watchlistData.unshift(peerData);
      } else {
        this.watchlistData.push(peerData);
      }

      let wData = [];
      for (let i = 0; i < this.watchlistData.length; i++) {
        wData = this.watchlistData[i].company_info.map((el) => {
          const addedRowData = this.addRowTableData.find((obj) => {
            return obj.ticker === el.ticker;
          });
          if (addedRowData) {
            addedRowData.isSelected = true;
            const m = el.mpt;
            el = addedRowData;
            el["mpt"] = m;
          }
          // let obj = Object.assign({}, el);
          return el;
        });
        this.watchlistData[i].company_info = JSON.parse(JSON.stringify(wData));
      }
      this.selectedMenuItem =
        this.watchlistData.length && this.watchlistData[0].watchername;
      this.recentlyVisited =
        this.watchlistData.length > 0 ? this.watchlistData[1].company_info : [];
    }
  }

  onWatchlistSelect(e, d) {
    this.selectedMenuItem = d.watchername;
    this.recentlyVisited = d.company_info;
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
  }

  updateTickers() {
    this.onTickerUpdate.emit(this.modalData);
  }

  onUpdateTickers(tickerData) {
    this.modalData = tickerData;
  }

  handleModalCancel() {
    this.onClose.emit(true);
    this.editChartModal.onCancelModal();
  }
}
